"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Step = _antd.Steps.Step;
/**
 * 步驟條
 */

var StepBar = function StepBar(_ref) {
  var _ref$current = _ref.current,
      current = _ref$current === void 0 ? 0 : _ref$current,
      _ref$steps = _ref.steps,
      steps = _ref$steps === void 0 ? [] : _ref$steps;
  return /*#__PURE__*/_react.default.createElement(_antd.Steps, {
    current: current
  }, steps.map(function (step, index) {
    return /*#__PURE__*/_react.default.createElement(Step, _extends({
      key: index
    }, step));
  }));
};

var _default = StepBar;
exports.default = _default;
StepBar.propTypes = {
  steps: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    description: _propTypes.default.string,
    subTitle: _propTypes.default.string
  })),
  current: _propTypes.default.number
};